import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UiService {
  @Output() sectionClicked: EventEmitter<string> = new EventEmitter();
  @Output() nextSection: EventEmitter<any> = new EventEmitter();
  constructor() {}
}
